import { ENV } from '@/infrastructure/env-config';
import { Platform } from '@/infrastructure/utils/app';

/**
 * 产品相关
 */
export default {
  demoProduct: ENV.isProd ? [
    { productId: 'bccbf14499', platformId: Platform.Android },
    { productId: 'd01e411bf0', platformId: Platform.IOS },
    { productId: '082badc84b', platformId: Platform.Electron },
    { productId: '3b22d90459', platformId: Platform.Windows },
  ] : [
    { productId: '129a7bcc6e', platformId: Platform.Android }, // 测试环境
  ],
};
